const style = {
  icon: {
    verticalAlign: 'middle',
  },
};

export default style;
